import RatingCategory from "../../Shared/RatingCategory";
import { useState, useEffect } from "react";
import TextBox from "../../Shared/TextBox";
import { useTrailsApi } from "../../../Hooks";
import {ReactComponent as SpinnerIcon} from "../../../assets/img/icons/spinner.svg";
import SendButton from "../../Shared/Buttons/SendButton";
import { useTranslation } from "react-i18next";
import { region } from "../../../Configs";

export default function RateTrail({ trail, onSuccess }) {
	const [ratings, setRatings] = useState([]);
    const [loading, setLoading] = useState(false);
    const [comment, setComment] = useState("");
    const trailApi = useTrailsApi();
    const [buttonEnabled, setButtonEnabled] = useState(false);
	const { t } = useTranslation();
	const isCaRegion = region === "CA";

	const ratingCategories = [
		t("categoryEasyAccess"),
		t("categoryGoodQuality"),
		t("categoryEasyToUse"),
		t("categoryClearThemes"),
		t("categoryInstructorMastery"),
		t("categoryWillApplyKnowledge"),
	];

    const handleSubmitRating = async () => {
        if(!buttonEnabled)
            return;

        setLoading(true);
        const ratingData = {
            trailId: trail.id,
            comment,
            categories : ratings
        };     

        await new Promise((r) => setTimeout(r, 500));
        const response = await trailApi.rateTrail(ratingData);
        if (response.status === 200) {
            onSuccess();
        }
        setLoading(false);
    }

    useEffect(() => {
        setButtonEnabled(ratings.filter((rating) => rating).length === ratingCategories.length);
    }
    , [ratings]);

	return (
		!trail?.rated ? (
			<div className="flex flex-col"> {loading ? <SpinnerIcon className="mx-auto" /> : <>
				<p className="font-dosisbold text-xl text-left text-playmove-darkgray">
					{t("rateThisTrail")}
				</p>
				<p className="mt-3 text-left font-inter text-sm">
					{!isCaRegion && (
						<>
							{t("rateAndGetCertificateTrail")}
							<br />
						</>
					)}
					{t("selectEachCategory")}
				</p>
				<div className="mt-8 flex flex-col gap-y-10">
					{ratingCategories.map((category, index) => {
						return (
							<RatingCategory
								key={index}
								value={ratings[index]?.rating}
								onChange={(value) => {
								const newRatings = [...ratings];
                                newRatings[index] = {
                                    name: category,
                                    rating: value
                                };
                                setRatings(newRatings);
                                }}
								category={category}
							/>
						);
					})}

					<TextBox
						label={t("leaveAComment")}
						className="text-left"
                        id="comment"
                        value={comment}
                        onChangeText={(e) => {
                            setComment(e.target.value);
                        }
                    }
					/>
				</div>
				<SendButton  
                onClick={handleSubmitRating} 
                className="mx-auto mt-5"
                enabled={buttonEnabled}/></>}
			</div>
		) : <span className="font-dosisbold">{t("thankYouForRatingTrail")}</span>
	);
}
